import { CheckboxProps, default as MuiCheckbox } from '@mui/material/Checkbox';

import { Square, SquareCheck, SquareMinus } from '../icons';

const Checkbox = (props: CheckboxProps) => {
  return (
    <MuiCheckbox
      icon={<Square fontSize='small' />}
      indeterminateIcon={<SquareMinus fontSize='small' color='primary' />}
      checkedIcon={<SquareCheck fontSize='small' />}
      {...props}
    />
  );
};

export default Checkbox;
